"use strict";
//@ts-check
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tolist = exports.fromlist = void 0;
var basic_1 = require("./basic");
function fromlist(arr, dtype) {
    if (dtype === void 0) { dtype = Float64Array; }
    if ((0, basic_1.isarray)(arr))
        return arr;
    if (typeof arr === "number")
        return (0, basic_1.new_NDArray)(new Float32Array([arr]), []);
    if (typeof arr === "boolean")
        return (0, basic_1.new_NDArray)(new Uint8Array([arr ? 1 : 0]), []);
    if (arr === basic_1._NDArray.prototype)
        throw new Error("Programming error");
    if (!Array.isArray(arr))
        throw new Error("Can't parse input of type ".concat(typeof arr, ": ").concat(arr));
    var shape = [];
    var root = arr;
    while (Array.isArray(root)) {
        shape.push(root.length);
        root = root[0];
        if (shape.length > 256)
            throw new Error("Circular reference or excessive array depth");
    }
    var flat = [];
    var pushToFlat = function (arr, axis) {
        var e_1, _a, e_2, _b;
        // Check consistency
        if (axis == shape.length - 1) {
            try {
                for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                    var elem = arr_1_1.value;
                    if (Array.isArray(elem))
                        throw new Error("Inconsistent shape");
                    flat.push(elem);
                    // Update dtype
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        else {
            if (!Array.isArray(arr))
                throw new Error("Inconsistent shape");
            try {
                for (var arr_2 = __values(arr), arr_2_1 = arr_2.next(); !arr_2_1.done; arr_2_1 = arr_2.next()) {
                    var sub = arr_2_1.value;
                    if (sub.length != shape[axis + 1])
                        throw new Error("Inconsistent shape: found sibling arrays of lengths ".concat(sub.length, " and ").concat(shape[axis + 1]));
                    pushToFlat(sub, axis + 1);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (arr_2_1 && !arr_2_1.done && (_b = arr_2.return)) _b.call(arr_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    };
    pushToFlat(arr, 0);
    var buffer = new dtype(flat);
    return (0, basic_1.new_NDArray)(buffer, shape);
}
exports.fromlist = fromlist;
function tolist(arr) {
    if ((0, basic_1.isarray)(this))
        return tolist;
    if (arr === null || typeof arr == "number" || typeof arr == "boolean")
        return arr;
    if (Array.isArray(arr))
        return arr.map(tolist);
    if (!((0, basic_1.isarray)(arr)))
        throw new Error("Expected MyArray. Got ".concat(typeof arr, ": ").concat(arr));
    arr = (0, basic_1.number_collapse)(arr);
    if (!((0, basic_1.isarray)(arr)))
        return arr;
    // let out = [], top;
    // let q = /**@type {[MyArray, any][]}*/([[arr, out]])
    // while (top = q.pop()) {
    //   let [arr, out] = top;
    //   if (arr.shape.length <= 1) {
    //     out.push(...arr.flat);
    //   } else {
    //     for (let i = 0; i < arr.shape[0]; i++) {
    //       let l = []
    //       out.push(l);
    //       q.push([arr.index(i), l]);
    //     }
    //   }
    // }
    // return out;
    function recursiveReshape(flatArr, shapeArr) {
        if (shapeArr.length === 0) {
            return flatArr.shift();
        }
        var innerShape = shapeArr.slice(1);
        var outerSize = shapeArr[0];
        var innerArray = [];
        for (var i = 0; i < outerSize; i++) {
            innerArray.push(recursiveReshape(flatArr, innerShape));
        }
        return innerArray;
    }
    var out = recursiveReshape(__spreadArray([], __read(arr.flat), false), arr.shape);
    return out;
}
exports.tolist = tolist;
